import type { SVGProps } from 'react'

export default function LogoBackdropBrand(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_8753_4303)">
        <rect width="36" height="36" rx="18" fill="#A56D00" fillOpacity="0.07" />
        <g filter="url(#filter0_ddi_8753_4303)">
          <circle cx="18" cy="18" r="14" fill="#A56D00" fillOpacity="0.07" shapeRendering="crispEdges" />
        </g>
      </g>
      <defs>
        <filter id="filter0_ddi_8753_4303" x="-4" y="-3" width="44" height="44" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.683333 0 0 0 0 0.480662 0 0 0 0 0.145208 0 0 0 0.45 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8753_4303" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.925 0 0 0 0 0.723233 0 0 0 0 0.389271 0 0 0 0.45 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_8753_4303" result="effect2_dropShadow_8753_4303" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_8753_4303" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0" />
          <feBlend mode="normal" in2="shape" result="effect3_innerShadow_8753_4303" />
        </filter>
        <clipPath id="clip0_8753_4303">
          <rect width="36" height="36" rx="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
